import React, { useState } from 'react';
import { Box, IconButton, Link, TextField, CircularProgress, Typography } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import FilterListIcon from '@material-ui/icons/FilterList';
import { DropdownFilter } from '../../../components/Planner/Filters/DropdownFilter';

import globals from '../../../globals/communityGlobals';
import KeyboardDateSelector from '../../../components/common/KeyboardDateTimeSelectors/KeyboardDateSelector';
import { isValidDate } from '../../../utils/dates';

const locale = globals.getArea('patients');
const maxChars = 150;
const defaultState = {
  forename: '',
  surname: '',
  nhsNumber: '',
  dateOfBirth: null,
  status: 1,
  postCode: '',
};

const statusOptions = [{ id: 0, name: 'All' }, { id: 1, name: 'Active' }, { id: 2, name: 'Inactive' }];

export default function PatientSearchFilters({ onSubmit, errorProps, events, isTableDataLoading }) {
  const [state, setState] = useState(defaultState);

  const handleClear = () => {
    setState(defaultState);
    onSubmit(defaultState);
  };

  const isValidDateOfBirth = () => {
    return isValidDate(state.dateOfBirth, true);
  };

  return (
    <form
      className="slick-page-header-section"
      onSubmit={e => {
        e.preventDefault();
        onSubmit(state);
      }}
      noValidate
      autoComplete="off"
    >
      <Box className="filter-section" display="flex" p={0} justifyContent="flex-start" px={1}>
        <Box p={1}>
          <FilterListIcon />
        </Box>
        <Box px={1} display="flex" alignItems="center" flexGrow={1}>
          <Box p={0} display="flex" textAlign="end">
            <Typography className="ellipsis mx-display-flex" variant="body1">
              {locale.getMsg('forename')}
            </Typography>
          </Box>
          <Box p={1} flexGrow={1}>
            <TextField
              name="forename"
              value={state.forename}
              fullWidth
              onChange={e => setState({ ...state, forename: e.target.value })}
              inputProps={{
                maxLength: maxChars,
              }}
            />
          </Box>
        </Box>
        <Box px={1} display="flex" alignItems="center" flexGrow={1}>
          <Box p={1} display="flex" textAlign="end">
            <Typography className="ellipsis mx-display-flex" variant="body1">
              {locale.getMsg('surname')}
            </Typography>
          </Box>
          <Box p={1} flexGrow={1}>
            <TextField
              name="surname"
              value={state.surname}
              fullWidth
              onChange={e => setState({ ...state, surname: e.target.value })}
              inputProps={{
                maxLength: maxChars,
              }}
            />
          </Box>
        </Box>
        <Box px={1} display="flex" alignItems="center" flexGrow={1}>
          <Box p={0} display="flex" textAlign="end">
            <Typography className="ellipsis mx-display-flex" variant="body1">
              {locale.getMsg('nhsNumber')}
            </Typography>
          </Box>
          <Box p={1} flexGrow={1}>
            <TextField
              name="nhsNumber"
              value={state.nhsNumber}
              fullWidth
              error={errorProps.includes('nhsNumber')}
              onChange={e => setState({ ...state, nhsNumber: e.target.value })}
            />
          </Box>
        </Box>
        <Box px={1} display="flex" alignItems="center">
          <Box p={0} display="flex" textAlign="end">
            <Typography className="ellipsis mx-display-flex" variant="body1">
              {locale.getMsg('dateOfBirth')}
            </Typography>
          </Box>
          <KeyboardDateSelector
            id="date-picker-inline-from"
            value={state.dateOfBirth}
            onChange={date => setState({ ...state, dateOfBirth: date })}
            className="calendar-picker-input"
            disableToolbar
          />
        </Box>
        {events.isSettingPatientsAsInactiveEnabled() && (
          <Box px={1} display="flex" alignItems="center">
            <Box p={0} display="flex" textAlign="end">
              <Typography className="ellipsis mx-display-flex" variant="body1">
                {locale.getMsg('status')}
              </Typography>
            </Box>
            <Box p={1} width={170}>
              <DropdownFilter
                data={statusOptions}
                defaultValue={[statusOptions[0].id]}
                filterKey={'status'}
                filterValue={state.status}
                onChange={(name, value) => setState({ ...state, status: value })}
              />
            </Box>
          </Box>
        )}
        <Box px={1} display="flex" alignItems="center">
          <Box p={0} display="flex" textAlign="end">
            <Typography className="ellipsis mx-display-flex" variant="body1">
              {locale.getMsg('postcode')}
            </Typography>
          </Box>
          <Box p={1}>
            <TextField
              name="postcode"
              value={state.postCode}
              onChange={e => setState({ ...state, postCode: e.target.value })}
            />
          </Box>
        </Box>
        <Box p={1}>
          <Link className="cancel-link" onClick={handleClear}>
            Clear
          </Link>
        </Box>
        <Box p={1}>
          {isTableDataLoading && (
            <IconButton size="small" className="search-icon">
              <CircularProgress size={18} color="inherit" />
            </IconButton>
          )}

          {!isTableDataLoading && (
            <IconButton type="submit" size="small" className="search-icon" disabled={!isValidDateOfBirth()}>
              <SearchIcon />
            </IconButton>
          )}
        </Box>
      </Box>
    </form>
  );
}
